import axiosInstance from "../../api/axios";

const data = (promise) => promise.then((response) => response.data);

const multipart = (file, onProgress) => {
  const formData = new FormData();
  formData.append("file", file);
  return {
    formData,
    config: {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event) => {
        if (onProgress && event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total));
        }
      },
    },
  };
};

const GeneralLedgerService = {
  getMeta: () => data(axiosInstance.get("/gl/meta")),

  getEntries: (params) => data(axiosInstance.get("/gl/entries", { params })),
  getEntry: (id) => data(axiosInstance.get(`/gl/entries/${id}`)),
  updateEntry: (id, payload) => data(axiosInstance.patch(`/gl/entries/${id}`, payload)),
  exportEntries: (params, format) =>
    axiosInstance.get("/gl/entries/export", {
      params: { ...params, format },
      responseType: "blob",
    }),

  getNotes: (entryId) => data(axiosInstance.get(`/gl/entries/${entryId}/notes`)),
  addNote: (entryId, body) => data(axiosInstance.post(`/gl/entries/${entryId}/notes`, { body })),
  deleteNote: (noteId) => data(axiosInstance.delete(`/gl/notes/${noteId}`)),

  getAttachments: (entryId) => data(axiosInstance.get(`/gl/entries/${entryId}/attachments`)),
  uploadAttachment: (entryId, file, onProgress) => {
    const { formData, config } = multipart(file, onProgress);
    return data(axiosInstance.post(`/gl/entries/${entryId}/attachments`, formData, config));
  },
  deleteAttachment: (attachmentId) => data(axiosInstance.delete(`/gl/attachments/${attachmentId}`)),
  downloadAttachment: (attachmentId) =>
    axiosInstance.get(`/gl/attachments/${attachmentId}/download`, { responseType: "blob" }),

  getStatements: (params) => data(axiosInstance.get("/gl/statements", { params })),
  getStatement: (id) => data(axiosInstance.get(`/gl/statements/${id}`)),
  uploadStatement: (file, onProgress) => {
    const { formData, config } = multipart(file, onProgress);
    return data(axiosInstance.post("/gl/statements", formData, config));
  },
  linkStatement: (id, payload) => data(axiosInstance.post(`/gl/statements/${id}/link`, payload)),
  reparseStatement: (id) => data(axiosInstance.post(`/gl/statements/${id}/reparse`)),
  deleteStatement: (id, force = false) =>
    data(axiosInstance.delete(`/gl/statements/${id}`, { params: force ? { force: 1 } : {} })),
  downloadStatement: (id) =>
    axiosInstance.get(`/gl/statements/${id}/download`, { responseType: "blob" }),

  getBankProfiles: (params) => data(axiosInstance.get("/gl/bank-profiles", { params })),
  getBankProfile: (id, reveal = false) =>
    data(axiosInstance.get(`/gl/bank-profiles/${id}`, { params: reveal ? { reveal: 1 } : {} })),
  createBankProfile: (payload) => data(axiosInstance.post("/gl/bank-profiles", payload)),
  updateBankProfile: (id, payload) => data(axiosInstance.put(`/gl/bank-profiles/${id}`, payload)),

  getCompanies: () => data(axiosInstance.get("/gl/companies")),
  createCompany: (payload) => data(axiosInstance.post("/gl/companies", payload)),
  updateCompany: (id, payload) => data(axiosInstance.put(`/gl/companies/${id}`, payload)),
  syncCompanyUsers: (id, userIds) =>
    data(axiosInstance.put(`/gl/companies/${id}/users`, { user_ids: userIds })),
  getAssignableUsers: () => data(axiosInstance.get("/gl/assignable-users")),

  getCounterparties: (params) => data(axiosInstance.get("/gl/counterparties", { params })),
  updateCounterparty: (payload) => data(axiosInstance.put("/gl/counterparties", payload)),
  reviewCounterpartyGroup: (payload) => data(axiosInstance.post("/gl/counterparties/review", payload)),
  searchPartyRecords: (params) => data(axiosInstance.get("/gl/counterparties/entities", { params })),
  getPartyMatches: (params) => data(axiosInstance.get("/gl/counterparties/matches", { params })),
  rejectPartyMatch: (payload) => data(axiosInstance.post("/gl/counterparties/matches/reject", payload)),

  getAuditLogs: (params) => data(axiosInstance.get("/gl/audit-logs", { params })),

  getIncomeReconciliation: (params) => data(axiosInstance.get("/gl/income-reconciliation", { params })),
  getIncomeReconciliationDetail: (incomeType, incomeId) =>
    data(axiosInstance.get(`/gl/income-reconciliation/${incomeType}/${incomeId}`)),
  scanIncomeReconciliation: (payload = {}) =>
    data(axiosInstance.post("/gl/income-reconciliation/scan", payload)),
  confirmIncomeReconciliation: (payload) =>
    data(axiosInstance.post("/gl/income-reconciliation/confirm", payload)),
  rejectIncomeReconciliation: (payload) =>
    data(axiosInstance.post("/gl/income-reconciliation/reject", payload)),
  unmatchIncomeReconciliation: (payload) =>
    data(axiosInstance.post("/gl/income-reconciliation/unmatch", payload)),
};

export default GeneralLedgerService;
